<template>
  <NumberField  :attribute="attribute" :format="format ?? metadataFormat() ?? '0'"  v-bind="$attrs"/>
</template>

<script>
import NumberField from "./NumberField.vue"
import Attribute from "../../xmlrdb-data/Attribute"

export default {
  name: "intField",
  components: {
    NumberField
  },
  props: {
    attribute: Attribute,
    format: String
  },  
  inheritAttrs: false,
  // Steuert in der Attribute - Komponente ob das erzeugte Label als Click-Label für die Input-Komponente agieren soll
  // clickableAttributeLabel: true, 
  clickableContainer: true,
  setup(props) {
    return  {
      metadataFormat: () => props.attribute.metadata.tagValueByName("format")
    }
  }
}
</script>

<style>

</style>